import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchByBillingLinkComponent } from './search-by-billing-link.component';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DlsDialogModule } from '@zelis/dls/dialog';
import { SearchByBillingLinkDialogComponent } from './search-by-billing-link-dialog/search-by-billing-link-dialog.component';
import { DlsButtonModule } from '@zelis/dls/button';

@NgModule({
  declarations: [
    SearchByBillingLinkComponent,
    SearchByBillingLinkDialogComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    MatIconModule,
    DlsDialogModule,
    DlsButtonModule,
  ],
  providers: [],
  exports: [SearchByBillingLinkComponent],
})
export class SearchByBillingModule {}
